import PropTypes from 'prop-types';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import { Link } from 'react-router-dom';
import './back-button.scss';

interface IBackButtonProps {
  to: string;
  children: string;
}

export const BackButton = ({ to, children }: IBackButtonProps): JSX.Element => (
  <Link className="back-button" to={to}  state={{ allowedTransition: true }}>
    <HiOutlineArrowLeft size={16} /> {children}
  </Link>
);

BackButton.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
};